import { useState, useEffect } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitButton } from "ui-components/Form";

import MDBox from "components/MDBox";
import { Card } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { formRender, initialValues, teamRoleValidation } from "./team-role-schema";
import TeamRoleInfo from "./components/TeamRoleInfo";
import { Success, Error } from "ui-components/Alert";

import { getTeamRole, editTeamRole } from "services/data.internal.service";
import Layout from "layouts/views/components/Layout";
import { useLocation } from "react-router-dom";
import { InboundLayout } from "ui-components/Layout";
function EditTeamRole() {
  const location=useLocation();
  const { teamName } = location.state;
  const [alert, setAlert] = useState(null);
  const [expanded, setExpanded] = useState([]);
  const [formValues, setFormValues] = useState(initialValues);
  const queryClient = useQueryClient();

  const onError = (data) => {
    setAlert(<Error data={data} onChange={setAlert} />);
  };

  const editTeamRoleMutation = useMutation(editTeamRole, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
      queryClient.invalidateQueries(["team-role"]);
    },
    onError,
  });

  useQuery({
    queryKey: ["team-role", { teamName }],
    queryFn: () => getTeamRole(teamName),
    onSuccess: (data) => {
      const { teamName: name, permission } = data.data.data;
      setFormValues({
        teamName: name,
        permission
      });
    },
    onError,
  });

  const form = useForm({
    defaultValues: formValues,
    values: formValues,
    resolver: yupResolver(teamRoleValidation),
  });

  const {
    register,
    control,
    formState: { errors },
    setValue,
    getValues,
    watch,
    handleSubmit,
    reset
  } = form;
  const teamRoleProp = {
    formRender,
    control,
    errors,
    watch,
    setValue,
    expanded,
    setExpanded,
    mode:"EDIT"
  };

  const onSubmit = async () => {
    window.scrollTo(0, 0);
    if (alert !== null) {
      setAlert(null);
    }
    const values = getValues();

    if (!values.permission || values.permission.length === 0) {
      setAlert(<Error content="Permissions are required" onChange={setAlert}/>);
      return;
    }
    const req = {
      ...values
    };

    editTeamRoleMutation.mutate(
      {
        teamName: teamName,
        req
      },
      {
        onSuccess: () => {
          reset();
          setExpanded([]);
        },
      }
    );
  };

  const editStatus = editTeamRoleMutation.status === "loading";

  return (
    <InboundLayout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Card sx={{ height: "100%" }}>
          <MDBox p={3}>
            <TeamRoleInfo {...teamRoleProp} />
          </MDBox>
          <MDBox p={3}>
            <SubmitButton label="Submit" disabled={editStatus} url="/user/team-role" />
          </MDBox>
        </Card>
      </form>
    </InboundLayout>
  );
}

export default EditTeamRole